export const ArrBlockchainTech = [
  {
    title: 'Blockchain Industries We Serve',
    des:'Nowadays blockchain is a trending part in various fields of industry. It offers a lot of benefits as follows',
    itemList:[
      ['Decentralized Exchange' , 'NFT Development' , 'Decentralized Exchange Development' , 'Centralized Exchange Development' , 'System Security Enhancement for CEX'],
      ['E-Wallet Development' , 'POS Application Development' , 'Private ( Enterprise) Blockchain Development' , 'ICO, IEO & STO Services']
    ]
  },
  {
    title: 'Blockchain Services',
    des1:[
      {
        title:'BLOCKCHAIN DEVELOPMENT ',
        text:'We offer full-stack of public blockchain development, including tailoring a public platform chain with protocols that are suitable to your requirements.'
      },
      {
        title:'DECENTRALIZED EXCHANGE DEVELOPMENT',
        text:'With our experience in developing many Decentralized Exchange on the market, we can help you develop your own DEX with competitive features.'
      },
      {
        title:'SYSTEM SECURITY ENHANCEMENT FOR CEX',
        text:'We build a security platform that can access millions of users with Amazon Web Services and Cloudflare CDN. Our system passed the PEN test and prevented top OWASP most critical web application security risks.'
      },
      {
        title:'POS APPLICATION DEVELOPMENT',
        text:'We provide Merchant/Point of Sale development involving end-to-end payment solutions to enable transactions in cryptocurrencies/fiats seamlessly.'
      },
    ],
    des2:[
      {
        title:'NFT DEVELOPMENT ',
        text:'We develop an easy-to-access NFT marketplace platform with multiple security layers and all the features we need to launch a marketplace.'
      },
      {
        title:'CENTRALIZED EXCHANGE DEVELOPMENT',
        text:'We offer a complete solution for making full-fledged white labels or an entire new centralized exchange, everything tailored to fit your requirements.'
      },
      {
        title:'E-WALLET DEVELOPMENT ',
        text:`Our digital wallet development service provides P2P and commercial transactions
        which are enabled for digital devices. Enhanced with maximum security measures!`
      },
      {
        title:'PRIVATE ( ENTERPRISE) BLOCKCHAIN DEVELOPMENT',
        text:`We provide Merchant/Point of Sale development involving end-to-end payment
        solutions to enable transactions in cryptocurrencies/fiats seamlessly.`
      },
    ],
  },
]

export const Tabs = [
  {
    id: "1",
    dev: `FRONTEND`,
    skill: [
      {
        skill: `Vuejs`,
      },
      {
        skill: `Reactjs`,
      },
      {
        skill: `Redux`,
      },
      {
        skill: `TypeScript`,
      },
      {
        skill: `Mobx`,
      },
      {
        skill: `RxJs`,
      },
      {
        skill: `GrapQL`,
      },
    ],
  },
  {
    id: "2",
    dev: `BACKEND`,
    skill: [
      {
        skill: `Vuejs`,
      },
      {
        skill: `Reactjs`,
      },
      {
        skill: `Redux`,
      },
      {
        skill: `TypeScript`,
      },
      {
        skill: `Mobx`,
      },
      {
        skill: `RxJs`,
      },
      {
        skill: `GrapQL`,
      },
      {
        skill: `Nodejs`,
      },
    ],
  },

  {
    id: "3",
    dev: `Blockchain`,
    skill: [
      {
        skill: `Vuejs`,
      },
      {
        skill: `Reactjs`,
      },
      {
        skill: `Redux`,
      },
      {
        skill: `TypeScript`,
      },
      {
        skill: `Mobx`,
      },
      {
        skill: `RxJs`,
      },
    ],
  },
  {
    id: "4",
    dev: `Mobile`,
    skill: [
      {
        skill: `Vuejs`,
      },
      {
        skill: `Reactjs`,
      },
      {
        skill: `Redux`,
      },
      {
        skill: `TypeScript`,
      },
      {
        skill: `Mobx`,
      },
    ],
  },
];
